var _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 6.5C7.33333 6.132 7.632 5.83333 8 5.83333C8.368 5.83333 8.66667 6.132 8.66667 6.5V9.16666C8.66667 9.53466 8.368 9.83333 8 9.83333C7.632 9.83333 7.33333 9.53466 7.33333 9.16666V6.5ZM7.33333 11.1667C7.33333 10.7987 7.632 10.5 8 10.5C8.368 10.5 8.66667 10.7987 8.66667 11.1667C8.66667 11.5347 8.368 11.8333 8 11.8333C7.632 11.8333 7.33333 11.5347 7.33333 11.1667ZM13.9098 12.7353C13.7571 13.0053 13.4598 13.1667 13.1145 13.1667H2.88513C2.5398 13.1667 2.24247 13.0053 2.09047 12.7353C2.01847 12.6087 1.9238 12.3507 2.1018 12.0573L7.2158 3.57867C7.52713 3.06267 8.47247 3.06267 8.7838 3.57867L13.8985 12.0573C14.0758 12.3507 13.9818 12.6087 13.9098 12.7353M15.0405 11.3687L9.9258 2.88933C9.52647 2.228 8.80647 1.83333 7.9998 1.83333C7.19313 1.83333 6.47313 2.228 6.07447 2.88933L0.959799 11.3687C0.580466 11.9973 0.569133 12.7533 0.929133 13.3907C1.31513 14.0753 2.06513 14.5 2.88513 14.5H13.1145C13.9351 14.5 14.6845 14.0753 15.0711 13.3907C15.4311 12.7533 15.4198 11.9973 15.0405 11.3687",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 6.5C7.33333 6.132 7.632 5.83333 8 5.83333C8.368 5.83333 8.66667 6.132 8.66667 6.5V9.16666C8.66667 9.53466 8.368 9.83333 8 9.83333C7.632 9.83333 7.33333 9.53466 7.33333 9.16666V6.5ZM7.33333 11.1667C7.33333 10.7987 7.632 10.5 8 10.5C8.368 10.5 8.66667 10.7987 8.66667 11.1667C8.66667 11.5347 8.368 11.8333 8 11.8333C7.632 11.8333 7.33333 11.5347 7.33333 11.1667ZM13.9098 12.7353C13.7571 13.0053 13.4598 13.1667 13.1145 13.1667H2.88513C2.5398 13.1667 2.24247 13.0053 2.09047 12.7353C2.01847 12.6087 1.9238 12.3507 2.1018 12.0573L7.2158 3.57867C7.52713 3.06267 8.47247 3.06267 8.7838 3.57867L13.8985 12.0573C14.0758 12.3507 13.9818 12.6087 13.9098 12.7353M15.0405 11.3687L9.9258 2.88933C9.52647 2.228 8.80647 1.83333 7.9998 1.83333C7.19313 1.83333 6.47313 2.228 6.07447 2.88933L0.959799 11.3687C0.580466 11.9973 0.569133 12.7533 0.929133 13.3907C1.31513 14.0753 2.06513 14.5 2.88513 14.5H13.1145C13.9351 14.5 14.6845 14.0753 15.0711 13.3907C15.4311 12.7533 15.4198 11.9973 15.0405 11.3687",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.5712dbecd7e7abf8359e8a4db740cd68.svg";
export { ForwardRef as ReactComponent };